import axios from 'axios';

const API_PATH = `${process.env.VUE_APP_FRONT_API}${process.env.VUE_APP_FRONT_CITY_TOWN_TAIWAN}`;

/** 取得縣市鄉鎮 */
export default () => axios.get(API_PATH);
